// Google Maps Configuration
// 
// API keys are loaded from environment variables (.env file)
// See .env.example for the template
//
// HOW TO GET YOUR API KEY:
// 1. Go to https://console.cloud.google.com/
// 2. Create a new project or select existing one
// 3. Enable these APIs:
//    - Maps JavaScript API
//    - Places API
//    - Directions API
//    - Geocoding API
// 4. Go to Credentials → Create API Key
// 5. Add the key to your .env file
// 6. IMPORTANT: Set up billing (you get $200 free monthly credit)

// API keys loaded from environment variables
export const PROD_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
const DEV_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY_DEV || '';
const USE_DEV_KEY = import.meta.env.VITE_USE_DEV_MAPS_KEY === 'true';

export const GOOGLE_MAPS_API_KEY = USE_DEV_KEY ? DEV_API_KEY : PROD_API_KEY;

// Libraries needed for different features
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry'];

// Default map center (Lakewood, NJ - Zip 08701) — fallback if settings not loaded
export const DEFAULT_MAP_CENTER = {
    lat: 40.0960,
    lng: -74.2177
};

// Default map zoom level — fallback if settings not loaded
export const DEFAULT_MAP_ZOOM = 13;

// Build map center from CompanySettings (call with settings from SettingsContext)
export const getMapCenter = (settings) => ({
    lat: Number(settings?.mapCenterLat) || DEFAULT_MAP_CENTER.lat,
    lng: Number(settings?.mapCenterLng) || DEFAULT_MAP_CENTER.lng,
});

// Build map zoom from CompanySettings
export const getMapZoom = (settings) => settings?.mapDefaultZoom || DEFAULT_MAP_ZOOM;

// Build autocomplete country restrictions from CompanySettings
const parseCountries = (settings) => {
    if (!settings?.autocompleteCountries) return ['us', 'ca'];
    try { return JSON.parse(settings.autocompleteCountries); }
    catch { return ['us', 'ca']; }
};

// Autocomplete options for address search — fallback (static)
export const AUTOCOMPLETE_OPTIONS = {
    componentRestrictions: { country: ['us', 'ca'] },
    fields: ['address_components', 'formatted_address', 'geometry', 'place_id']
};

// Settings-aware autocomplete options
export const getAutocompleteOptions = (settings) => ({
    componentRestrictions: { country: parseCountries(settings) },
    fields: ['address_components', 'formatted_address', 'geometry', 'place_id']
});
